module.exports = __webpack_public_path__ + "images/questions/hikaQ_header_e929034708e9c888342b98396a44f696.png";